/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlEntityStatsCyberBenchmark
 */
export interface ControlEntityStatsCyberBenchmark {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlEntityStatsCyberBenchmark
     */
    overall?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlEntityStatsCyberBenchmark
     */
    ransomware?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlEntityStatsCyberBenchmark
     */
    ftf?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ControlEntityStatsCyberBenchmark
     */
    breach?: { [key: string]: any; };
}

/**
 * Check if a given object implements the ControlEntityStatsCyberBenchmark interface.
 */
export function instanceOfControlEntityStatsCyberBenchmark(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityStatsCyberBenchmarkFromJSON(json: any): ControlEntityStatsCyberBenchmark {
    return ControlEntityStatsCyberBenchmarkFromJSONTyped(json, false);
}

export function ControlEntityStatsCyberBenchmarkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityStatsCyberBenchmark {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'overall': !exists(json, 'overall') ? undefined : json['overall'],
        'ransomware': !exists(json, 'ransomware') ? undefined : json['ransomware'],
        'ftf': !exists(json, 'ftf') ? undefined : json['ftf'],
        'breach': !exists(json, 'breach') ? undefined : json['breach'],
    };
}

export function ControlEntityStatsCyberBenchmarkToJSON(value?: ControlEntityStatsCyberBenchmark | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'overall': value.overall,
        'ransomware': value.ransomware,
        'ftf': value.ftf,
        'breach': value.breach,
    };
}

